import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import AvatarPreview from '@sprinx/react-mui-components/AvatarPreview';
var useStyles = makeStyles(function () {
  return {
    root: function root(_ref) {
      var flexDirection = _ref.flexDirection;
      return {
        display: 'flex',
        flexDirection: flexDirection
      };
    },
    content: {},
    baseline: {
      alignSelf: 'baseline'
    },
    center: {
      alignSelf: 'center'
    },
    end: {
      alignSelf: 'flex-end'
    },
    start: {
      alignSelf: 'flex-start'
    },
    stretch: {
      alignSelf: 'stretch'
    }
  };
}, {
  name: 'SxComProductImageDecoratedAdornment'
});

function ProductImageDecoratedAdornment(_ref2) {
  var alignSelf = _ref2.alignSelf,
      bgColor = _ref2.bgColor,
      children = _ref2.children,
      pClasses = _ref2.classes,
      className = _ref2.className,
      flexDirection = _ref2.flexDirection,
      fontSize = _ref2.fontSize,
      icon = _ref2.icon,
      imageSrc = _ref2.imageSrc,
      margin = _ref2.margin,
      size = _ref2.size,
      rest = _objectWithoutProperties(_ref2, ["alignSelf", "bgColor", "children", "classes", "className", "flexDirection", "fontSize", "icon", "imageSrc", "margin", "size"]);

  var classes = useStyles({
    classes: pClasses,
    alignSelf: alignSelf,
    flexDirection: flexDirection
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className, classes[alignSelf])
  }), /*#__PURE__*/React.createElement(AvatarPreview, {
    className: classes.content,
    size: size,
    margin: margin,
    bgColor: bgColor,
    fontSize: fontSize,
    icon: icon,
    imageSrc: imageSrc
  }, children));
}

ProductImageDecoratedAdornment.propTypes = {
  alignSelf: PropTypes.oneOf(['start', 'end', 'center', 'baseline', 'stretch']),

  /**
   * Barva pozadi.
   */
  bgColor: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.shape({
    content: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  component: PropTypes.elementType,
  flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto', 'inherit'])]),

  /**
   * Element icony. Ked ma hodnotu bude pouzite ako obsah.
   */
  icon: PropTypes.element,
  imageSrc: PropTypes.string,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),

  /**
   * Velikost avataru. Muze byt jedena z variant odpovidajici velikostem
   *
   * - 'small' 32px
   * - 'normal' 40px
   * - 'large' 56px
   *
   * nebo vlatni velikost v px.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(['normal', 'small', 'large']), PropTypes.number])
};
ProductImageDecoratedAdornment.defaultProps = {
  alignSelf: undefined,
  bgColor: undefined,
  children: undefined,
  classes: undefined,
  className: undefined,
  component: undefined,
  flexDirection: 'column',
  fontSize: 'auto',
  icon: undefined,
  imageSrc: undefined,
  margin: 'dense',
  size: 'small'
};
export default ProductImageDecoratedAdornment;